import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoiceItem\DeleteInvoiceItemController::deleteMethod
* @see app/Http/Controllers/InvoiceItem/DeleteInvoiceItemController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}'
*/
export const deleteMethod = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/invoicing/{invoice}/invoice-item/{invoice_item}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\InvoiceItem\DeleteInvoiceItemController::deleteMethod
* @see app/Http/Controllers/InvoiceItem/DeleteInvoiceItemController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}'
*/
deleteMethod.url = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
            invoice_item: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
        invoice_item: typeof args.invoice_item === 'object'
        ? args.invoice_item.id
        : args.invoice_item,
    }

    return deleteMethod.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace('{invoice_item}', parsedArgs.invoice_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoiceItem\DeleteInvoiceItemController::deleteMethod
* @see app/Http/Controllers/InvoiceItem/DeleteInvoiceItemController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}'
*/
deleteMethod.delete = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\InvoiceItem\DeleteInvoiceItemController::undo
* @see app/Http/Controllers/InvoiceItem/DeleteInvoiceItemController.php
* @route '/api/invoicing/{invoice}/invoice-item/{id}/undo-delete'
*/
export const undo = (args: { invoice: string | number | { id: string | number }, id: string | number } | [invoice: string | number | { id: string | number }, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/invoice-item/{id}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\InvoiceItem\DeleteInvoiceItemController::undo
* @see app/Http/Controllers/InvoiceItem/DeleteInvoiceItemController.php
* @route '/api/invoicing/{invoice}/invoice-item/{id}/undo-delete'
*/
undo.url = (args: { invoice: string | number | { id: string | number }, id: string | number } | [invoice: string | number | { id: string | number }, id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
            id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
        id: args.id,
    }

    return undo.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoiceItem\DeleteInvoiceItemController::undo
* @see app/Http/Controllers/InvoiceItem/DeleteInvoiceItemController.php
* @route '/api/invoicing/{invoice}/invoice-item/{id}/undo-delete'
*/
undo.get = (args: { invoice: string | number | { id: string | number }, id: string | number } | [invoice: string | number | { id: string | number }, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvoiceItem\DeleteInvoiceItemController::undo
* @see app/Http/Controllers/InvoiceItem/DeleteInvoiceItemController.php
* @route '/api/invoicing/{invoice}/invoice-item/{id}/undo-delete'
*/
undo.head = (args: { invoice: string | number | { id: string | number }, id: string | number } | [invoice: string | number | { id: string | number }, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteInvoiceItemController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteInvoiceItemController